// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"a1976d726592e83737ea","655":"ed3cb19c40aa1b92cc57"}[chunkId] + ".js";
};